import { Injectable } from "@angular/core";

import { ToastController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  async showToast(msg = "Operation completed Successfully") {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      cssClass: "success-toast",
      position: "top",
      color: "success",
    });

    toast.present();
  }

  async showErrorToast(msg: string) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      cssClass: "error-toast",
      position: "top",
      color: "danger",
    });

    toast.present();
  }
}
